import { Link } from 'react-router-dom';
import styled from 'styled-components';

// Components
import { Collapse } from 'top-component-library';

// Constants
import { button } from 'constants/style';

export const Body = styled.div`
  padding: 1.25rem;
`;

export const Container = styled.div`
  background-color: var(--color-neutral__card-background);
  border-radius: var(--border-radius__small);
  border: 1px solid var(--color-neutral__line);
  overflow: hidden;
`;

export const Distance = styled.span`
  color: var(--color-neutral__title-active);
  display: block;
  font-size: 0.625rem;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1.2;
  padding-bottom: 0.75rem;
  opacity: 0.7;
  text-transform: uppercase;
`;

export const Name = styled.span`
  color: var(--color-neutral__title-active);
  display: block;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.2;
  letter-spacing: 0.5px;
  padding-bottom: 0.75rem;
`;

export const OrderButton = styled(Link)`
  align-items: center;
  background-color: var(--color-button-landing-page__regular);
  border-radius: 0;
  border: 1px solid var(--color-button-landing-page__regular);
  color: white;
  display: flex;
  font-size: 0.75rem;
  font-weight: bold;
  height: auto;
  justify-content: center;
  letter-spacing: 2px;
  padding: 0.5rem;
  min-height: ${button.small}px;
  text-align: center;
  text-transform: uppercase;
  transition: opacity 0.3s ease;
  width: 100%;

  &:focus,
  &:hover {
    color: white;
    opacity: 0.9;
  }
`;

export const PhoneAddress = styled.div`
  font-size: 0.75rem;
  line-height: 1.5;
  opacity: 0.7;
`;

export const CollapseSection = styled(Collapse)`
  && {
    background-color: var(--color-neutral__card-background);
    border-color: var(--color-neutral__line);
    border-width: 1px 0 0 0;

    .ant-collapse-content-box {
      padding: 1.25rem;
    }

    .ant-collapse-header {
      font-weight: bold;
      font-size: 0.875rem;
      line-height: 1.2;
      letter-spacing: 0.5px;
      padding: 1rem 3rem 1rem 1.25rem;

      .ant-collapse-arrow {
        right: 1.25rem;
        top: 7px;
      }

      &[aria-expanded='true'] {
        svg {
          transform: rotate(90deg);
        }
      }
    }

    svg {
      transform: rotate(270deg);

      path {
        stroke-width: 2.5px;
      }
    }
  }
`;

export const StoreHoursText = styled.div`
  * {
    color: var(--color-neutral__body);
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    line-height: 1.5;
    margin-bottom: 0;
    margin-top: 0.25rem;
    opacity: 0.7;
    word-break: break-word;

    &:first-child {
      margin-top: 0;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1rem;

    &:first-of-type {
      margin-top: 0;
    }
  }
`;

export const VendorList = styled(Collapse.Panel)`
  &&&& .ant-collapse-content-box {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;

export const ListItem = styled.div`
  color: var(--color-neutral__title-active);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: flex;
  align-items: center;
  height: 4rem;
`;

export const VendorName = styled.span`
  color: var(--color-neutral__title-active);
  display: block;
  font-weight: bold;
  font-size: 0.75rem;
  line-height: 1.2;
  letter-spacing: 0.5px;
`;

export const VendorLogo = styled.img`
  max-height: 2.25rem;
  margin-right: 1rem;
`;
